import { render, staticRenderFns } from "./Version.vue?vue&type=template&id=ceb26838&scoped=true"
import script from "./Version.vue?vue&type=script&lang=js"
export * from "./Version.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb26838",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ceb26838')) {
      api.createRecord('ceb26838', component.options)
    } else {
      api.reload('ceb26838', component.options)
    }
    module.hot.accept("./Version.vue?vue&type=template&id=ceb26838&scoped=true", function () {
      api.rerender('ceb26838', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Version.vue"
export default component.exports